<template>
    <el-popover
            placement="right"
            width="200"
            trigger="hover">
        <el-button
                slot="reference"
                plain
                icon="el-icon-more" size="small"></el-button>
        <slot/>
    </el-popover>
</template>

<script>
    export default {
        name: 'mak-more',
    };
</script>
